/**
 * @file 获取会员订阅信息
 */

import {useUserBenefitProfile, useProjectBenefitProfile} from './useBenefitProfile';
import {useUrlProjectId} from '@/hooks/useUrlProjectId';
import type {MemberInfo} from '@/services/commerce/entities/benefit';

export interface UseMemberInfoResult {
    memberInfo: MemberInfo | undefined;
    isLoading: boolean;
}

/**
 * 当前用户的会员订阅信息
 */
export const useMemberInfo = (): UseMemberInfoResult => {
    const {data, isLoading} = useUserBenefitProfile();
    return {
        memberInfo: data?.memberInfo,
        isLoading,
    };
};

/**
 * 上下文自适应的会员订阅信息
 */
export const useContextMemberInfo = (): UseMemberInfoResult => {
    const projectId = useUrlProjectId();
    const userProfile = useUserBenefitProfile();
    const projectProfile = useProjectBenefitProfile();

    const {data, isLoading} = projectId ? projectProfile : userProfile;

    return {
        memberInfo: data?.memberInfo,
        isLoading,
    };
};
